import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';

import { getMessages } from '../locales';
import { getUserDetails } from '../../../common/utils/Persist';

const DEFAULT_LOCALE = 'en';

const INITIAL_STATE = {
  app: {
    locale: DEFAULT_LOCALE,
    isBlockingLoaderActive: false,
    messages: getMessages(DEFAULT_LOCALE),
    isLoggedIn: true,
    active_hotel_id: null,
    userDetails: getUserDetails('user_details', {}),
    hasAppInitError: false
  },
  toast: {
    toasts: []
  },
  entities: {
    hotels: {},
  }
};

export const getMergedInititalState = state => {
  const inititalState = cloneDeep(INITIAL_STATE);
  return merge(inititalState, state);
};

export default INITIAL_STATE;
